/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateWorkPackageCategoryRequest } from '../../models/update-work-package-category-request';
import { WorkPackageCategoryDto } from '../../models/work-package-category-dto';

export interface UpdateWorkPackageCategory$Params {
  id: string;
      body: UpdateWorkPackageCategoryRequest
}

export function updateWorkPackageCategory(http: HttpClient, rootUrl: string, params: UpdateWorkPackageCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkPackageCategoryDto>> {
  const rb = new RequestBuilder(rootUrl, updateWorkPackageCategory.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WorkPackageCategoryDto>;
    })
  );
}

updateWorkPackageCategory.PATH = '/v0/workPackageCategories/{id}';
